import { Modal, getDateType, message } from 'ui';
import { useCreateVideo } from '../../queries';
import { VideoCreateForm } from './video-create-form';
import type { VideoCreateFormValues } from './video-create-form';

type P = {
  isOpened: boolean;
  onClose: () => void;
  onNavigateToVideoDetail: (id: string) => Promise<void>;
};

const VideoCreateModal = ({ isOpened, onClose, onNavigateToVideoDetail }: P) => {
  const { isPending: isLoading, mutate: createVideo } = useCreateVideo();

  const onSave = (values: VideoCreateFormValues) => {
    createVideo(
      {
        coverPhoto: values.coverPhoto?.[0],
        featuredInChannels: values.featuredInChannels,
        htmlContent: values.htmlDescription,
        name: values.name,
        organizationId: values.organization.value,
        recordedAt: getDateType(values.recordedAt),
        showInChannels: values.showInChannels,
        tags: values.tags,
        textContent: values.textDescription,
      },
      {
        onError() {
          message.error('Something went wrong, video couldn’t be added');
        },
        async onSuccess(data) {
          message.success('Video added successfully');
          await onNavigateToVideoDetail(data.video.id);
          onClose();
        },
      },
    );
  };

  return (
    <Modal isOpened={isOpened} maskClosable={false} onCancel={onClose} title="Add video" width="medium">
      <Modal.HugContent>
        <VideoCreateForm isLoading={isLoading} onSuccess={onSave} />
      </Modal.HugContent>
    </Modal>
  );
};

export default VideoCreateModal;
